import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { FEATURE_TYPE } from './FeatureManager.type';
import { Icon, Select } from 'Components';
import ToggleButton from 'Components/ToggleButton';
import { FEATURE_ICONS } from './FeatureManager.constant';
import Icons from 'Icons/Icons';
import { useStores } from 'Hooks/useStore';
import FeatureHeader from './components/FeatureHeader';
import ConfirmModal from './components/ConfirmModal';
import EmptyState from 'PhishingManager/components/EmptyState';
import Header from 'PhishingManager/components/Header';
import "./FeatureManager.scss";

const FeatureManager = () => {
    const [modalData, setModalData] = useState<FEATURE_TYPE | null>(null);
    const { t } = useTranslation();
    const { authStore, systemsStore } = useStores();
    const isSuperAdmin = authStore.isCurrentUserSuperAdmin;
    const { selectedTenant, featureList, featureLoading } = systemsStore;

    const getUpdatedData = (updatedFeatures: FEATURE_TYPE[]) => {
        systemsStore.updateFeatureList(updatedFeatures);
    }

    return <Spin spinning={featureLoading}>
        {selectedTenant.value ? <div className='feature-manager-container'>
            <FeatureHeader title={t(`featureManager.${isSuperAdmin ? "superAdmin" : ""}Title`)} description={t(`featureManager.${isSuperAdmin ? "superAdmin" : ""}Description`)} />
            <div className='list-section'>
                {featureList.map(item => {
                    const isTrainingCard = item.featureName === "Training" ? "training-card" : "";
                    const icon = FEATURE_ICONS[item.featureName] as keyof typeof Icons;
                    const status = item.isEnabled ? "enabled" : "disabled";
                    const baseText = 'profile.notifications'
                    return <div className={`feature-card ${status} ${isTrainingCard}`} key={item.featureId}>
                        <div className='icon'>
                            <Icon type={icon} />
                        </div>
                        <FeatureHeader title={item.featureName} description={item.description} />
                        {isSuperAdmin ? <ToggleButton prefixText={baseText} checked={item.isEnabled} setChecked={() => setModalData(item)} /> : <div className='prefix'>{t(`${baseText}.${status}`)}</div>}
                    </div>
                })}
            </div>
            {modalData?.featureId && <ConfirmModal {...{ modalData, selectedTenant, getUpdatedData }} hideModal={() => setModalData(null)} />}
        </div> : <EmptyState
            title={t('phishingManager.emptyState.noTenant.title')}
            description={[
                t('phishingManager.emptyState.noTenant.description1'),
                t('featureManager.noTenantDescription')
            ]}
            actionLabel={null} />}
    </Spin>
}

export default observer(FeatureManager);